import { render, staticRenderFns } from "./StartUpWizard.vue?vue&type=template&id=c9ec9e4c&scoped=true"
import script from "./StartUpWizard.vue?vue&type=script&lang=js"
export * from "./StartUpWizard.vue?vue&type=script&lang=js"
import style0 from "./StartUpWizard.vue?vue&type=style&index=0&id=c9ec9e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ec9e4c",
  null
  
)

export default component.exports